module.exports = __webpack_public_path__ + "static/media/29ADMSPC36.0adc0b22.jpg";